import { FETCH_POPULAR_REQUESTED } from "./actions";
import { POPULAR_LOADED } from "./actions";
import { POPULAR_ERROR } from "./actions";
import { LOAD_MORE } from "./actions";
import { LOAD_MORE_REQUESTED } from "./actions";

const defaultState = {
  moviesPopular: [],
  loading: true,
  error: null,
  page: 1
};

export const popularReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_POPULAR_REQUESTED:
      return {
        moviesPopular: [],
        loading: true,
        error: null,
        page: state.page
      };

    case POPULAR_LOADED:
      return {
        moviesPopular: action.payload,
        loading: false,
        error: null,
        page: state.page
      };

    case POPULAR_ERROR:
      return {
        moviesPopular: [],
        loading: false,
        error: true,
        page: state.page
      };
    case LOAD_MORE_REQUESTED:
      return {
        moviesPopular: state.moviesPopular,
        loading: false,
        error: null,
        page: state.page + 1
      };
    case LOAD_MORE:
      return {
        moviesPopular: [...state.moviesPopular, ...action.payload],
        loading: false,
        error: null,
        page: state.page
      };

    default:
      return state;
  }
};
